const t = "button_zuser", o = {
  button: t
};
export {
  t as button,
  o as default
};
//# sourceMappingURL=orderButton.module.scss.js.map
